import React, { useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Progress from './progress';
import { useHistory } from 'react-router-dom';

import {
  // actions
  closePopup, showPopup,
  //selectors
  isOpenedSelector, loadingSelector, contentSelector, classValueSelector, errorSelector
} from '../../ducks/popup';

function useHookWithRefCallback(dispatch) {
  const ref = useRef(null);
  const history = useHistory();

  const setRef = useCallback(node => {
    const node$ = (node) ? node : ref.current;
    const click$ = node$.querySelectorAll('[href*="<%= BoardSettings.BoardsUrlPrefix %>"]');
    if (ref.current) {
      click$.forEach((link) =>
        link.removeEventListener('click', handleLinkClick)
      );
    }

    if (node) {
      click$.forEach((link) =>
        link.addEventListener('click', handleLinkClick)
      );
    }
    // Save a reference to the node
    ref.current = node
  }, []);



  const handleLinkClick = (event) => {
    const link = event.currentTarget
    const href = link.getAttribute('href')
    const target = link.getAttribute('target')
    const url = new URL(href || '', window.location.origin)

    const isInternalLink = url.origin === window.location.origin
    const isOpenedInSameWindow = !target || target === '_self'
    const isLeftButtonClick = event.button === 0

    const hash = link.hash;
    const popupname = findPageName(link);

    const isModifierKeyPressed =
      event.altKey || event.ctrlKey || event.metaKey || event.shiftKey

    if (
      isInternalLink &&
      isOpenedInSameWindow &&
      isLeftButtonClick &&
      !isModifierKeyPressed
    ) {
      event.preventDefault();
      dispatch(closePopup());
      staticModalRedirect({ popupname, hash });
    }
  }

  const findPageName = (link) => {
    if (link.pathname.includes('boardfaq.aspx')) {
      return 'FAQ';
    } else if (link.pathname.includes('boardhelp.aspx')) {
      return 'HELP';
    }
  }

  const delay = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const staticModalRedirect = async (args) => {
    await delay(200);
    dispatch(showPopup(args.popupname));
    if (typeof args.hash === 'string' && args.hash !== "") {
      const response = await retryFunc(findNodeAsyncFunction.bind(this, args, 1000), 5);
      const result = await response();
      result.node[0].click();
      return;
    }
    history.push(args.hash);
  }

  return [setRef]
}

const retryFunc = (fun, reties) => {
  let attempt = 0;
  let doTry = (...args) => {
    attempt++;
    return fun(...args)
      .catch((err) => {
        if (attempt <= reties) {
          return doTry(...args);
        } else {
          return Promise.reject(err);
        }
      });
  }
  return doTry;
}

const findNodeAsyncFunction = (args, delay) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const node$ = document.querySelectorAll("div.con [href*='" + args.hash + "']");
      (node$.length > 0) ? resolve({ node: node$ }) : reject({ node: node$ });
    }, delay);
  });
}



export default function Popup(props) {
  const dispatch = useDispatch();
  const isOpen = useSelector(isOpenedSelector);
  const content = useSelector(contentSelector);
  const loading = useSelector(loadingSelector);
  const classValue = useSelector(classValueSelector);
  const error = useSelector(errorSelector);
  const [ref] = useHookWithRefCallback(dispatch);

  const handleClosePopup = () => dispatch(closePopup());

  const getBody = () => {
    if (loading) return <Progress />;
    if (error) return <div>Oops, something happend wrong</div>
    return <div ref={ref} dangerouslySetInnerHTML={{ __html: content }} />;
  }

  const getOtherProps = () => {
    const props = {};

    if (classValue) props.className = classValue;

    return props;
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleClosePopup}
      {...getOtherProps()}
    >
      <DialogContent>
        {getBody()}
      </DialogContent>
      <DialogActions>
        {!loading && <Button color="primary" onClick={handleClosePopup}>Close</Button>}
      </DialogActions>
    </Dialog>
  )
}